import { Link } from "react-router-dom";

const ServiceNavbar = () => {
  return (
    <div className="servicenavbar">
      <Link to="../cpa">
        <div className="servicesq">CPA</div>
      </Link>
      <Link to="../cma">
        <div className="servicesq">CMA</div>
      </Link>
      <Link to="../ea">
        <div className="servicesq">
          EA        
        </div>
      </Link>
      <Link to="../cpe">
        <div className="servicesq">
          CPE        
        </div>
      </Link>
      <Link to="../cia">
        <div className="servicesq">
          CIA       
        </div>
      </Link>
      <Link to="../csu">
        <div className="servicesq">
          CPA
          <div className="secsub">學分班</div>
        </div>
      </Link>
      
    </div>
  );
};

export default ServiceNavbar;
